import type { IPaymentItemOptionGroup } from "@/data/model/Order";
import { Format } from "@/data/util/Format";

import { Component } from "@/shared/elements/Component";

import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";

import { PaymentItemOption } from "./PaymentItemOption";

export class PaymentItemOptionGroup extends Component {
    public readonly optionGroup: IPaymentItemOptionGroup;
    public readonly isParentItemCancelled: boolean;
    public readonly displayPrice: boolean;

    constructor(optionGroup: IPaymentItemOptionGroup, isParentItemCancelled: boolean, displayPrice: boolean = false) {
        super();
        this.optionGroup = optionGroup;
        this.isParentItemCancelled = isParentItemCancelled;
        this.displayPrice = displayPrice;

        this.$element = this.drawElement();
    }

    protected drawElement() {
        const optionGroup = this.optionGroup;
        const optionGroupName = this.getDisplayName();

        // draw option group fields
        const $element = $('<div class="group" />');

        if (optionGroupName != null) $element.append(`<div class="name">${optionGroupName}</div>`);

        const $options = $('<div class="entries" />').appendTo($element);

        // draw option group options (order items)
        for (const option of optionGroup.items) {
            PaymentItemOption.render($options, option, this.isParentItemCancelled, this.displayPrice);
        }

        return $element;
    }

    private getDisplayName() {
        if (this.optionGroup.displayName == false) return null;

        const name = getNameInLocationLanguage(this.optionGroup, true);
        return name ? Format.htmlEscape(name) : null;
    }

    public static render(
        $appendToTarget: JQuery,
        optionGroup: IPaymentItemOptionGroup,
        isParentItemCancelled: boolean,
        displayPrice: boolean = false
    ): PaymentItemOptionGroup {
        const component = new PaymentItemOptionGroup(optionGroup, isParentItemCancelled, displayPrice);
        component.renderTo($appendToTarget);

        return component;
    }
}
